import * as React from 'react';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@material-ui/core';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

export interface ConfirmDialogProps {
  open: boolean;
  loading?: boolean;
  onConfirm: () => void;
  onClose: () => void;
  title: string;
  message?: string;
  yesLabel: string;
  noLabel: string;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  loading = false,
  onConfirm,
  onClose,
  title,
  message,
  yesLabel,
  noLabel
}) => {
  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle disableTypography>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <HelpOutlineIcon color="primary" />
          <span style={{ fontWeight: 600, fontSize: 16 }}>{title}</span>
        </div>
      </DialogTitle>
      {message && (
        <DialogContent>
          <DialogContentText style={{ color: 'rgba(0, 0, 0, 0.87)', marginBottom: 0 }}>
            {message}
          </DialogContentText>
        </DialogContent>
      )}
      <DialogActions style={{ padding: '8px 16px 16px' }}>
        <Button
          variant="outlined"
          color="default"
          disabled={loading}
          onClick={onClose}
        >
          {noLabel}
        </Button>
        <Button
          variant="contained"
          color="secondary"
          disabled={loading}
          onClick={onConfirm}
          startIcon={loading ? <CircularProgress size={16} color="inherit" /> : undefined}
        >
          {yesLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
